exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ScanInfoModal-module__modalContent2___2IUJQ .ScanInfoModal-module__image-wrapper___2cybd{max-width:500px;display:flex;justify-content:center;margin:0 auto 40px}.ScanInfoModal-module__modalContent2___2IUJQ .ScanInfoModal-module__image-wrapper___2cybd img{width:400px;margin-left:100%;margin-right:100%}.ScanInfoModal-module__modalContent2___2IUJQ h1,.ScanInfoModal-module__modalContent2___2IUJQ p{margin-bottom:25px;padding-left:10px}.ScanInfoModal-module__modalContent2___2IUJQ .ScanInfoModal-module__buttons-wrapper___2k3R8{margin-top:2rem;display:grid;grid-auto-flow:column;gap:.5rem;justify-content:center}", ""]);

// exports
exports.locals = {
	"modalContent2": "ScanInfoModal-module__modalContent2___2IUJQ",
	"image-wrapper": "ScanInfoModal-module__image-wrapper___2cybd",
	"buttons-wrapper": "ScanInfoModal-module__buttons-wrapper___2k3R8"
};